





















































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

// Components
import PostRegistrationRequiredFields from '@/components/Login/PostRegistrationRequiredFields.vue';
import Loading from '@/components/Global/Loading.vue';
import Checkbox from '@/components/Form/Checkbox.vue';

// Services
import User from '@/services/User';
import Auth from '@/services/Auth';
import Policy from '@/services/Policy';
import { captureException as SentryCaptureException } from '@sentry/browser';
import Brand from '@/services/Brand';
import Alert from '@/components/Global/Alert.vue';
import { mapGetters } from 'vuex';

import cloneDeep from 'lodash/cloneDeep';

@Component({
	name: 'PagePostRegistration',
	components: {
		PostRegistrationRequiredFields,
		Loading,
		Checkbox,
		Alert,
	},
})
export default class PostRegistration extends Vue {
	@State('user', { namespace: 'Auth' }) private user: any;
	@Getter('policies', { namespace: 'Policy' }) private policies: any;
	private data: {
		policy_number: string;
		registration_key: string;
	};
	private loading: boolean;
	private error: boolean;
	private riskMngrSuccess: boolean;
	private riskmngr: boolean;
	private Brand: typeof Brand = Brand;

	constructor() {
		super();

		this.data = {
			policy_number: '',
			registration_key: '',
		};
		this.loading = false;
		this.error = false;
		this.riskMngrSuccess = false;
		this.riskmngr = false;
	}

	get details() {
		return Brand.getBrandInformation();
	}

	get submitDisabled() {
		if (!this.riskmngr) {
			if (this.data.policy_number === '' && this.data.registration_key === '') {
				return true;
			} else if (this.data.policy_number !== '' && this.data.registration_key !== '') {
				return false;
			}

			return true;
		}

		return false;
	}

	private async riskMngrSubmit() {
		this.loading = true;

		try {
			const sendRequest = await User.postRegistration({
				risk_manager: true,
			});

			this.loading = false;
			this.riskMngrSuccess = true;
		} catch (e) {
			SentryCaptureException(e);
			this.loading = false;
			this.error = true;
		}
	}

	private async agreeAndContinue() {
		this.loading = true;

		try {
			const register = await User.postRegistration({
				risk_manager: false,
				policy_num: this.data.policy_number,
				reg_key: this.data.registration_key,
			});

			try {
				Auth.resumeSession();
				this.$router.push({
					name: 'home',
				});
			} catch (e) {
				SentryCaptureException(e);
			}
		} catch (e) {
			SentryCaptureException(e);
			this.loading = false;
			this.error = true;
		}
	}

	private async created() {
		if (this.policies && this.policies.length === 1) {
			this.data.policy_number = this.policies[0].policy_number;
			this.data.registration_key = this.policies[0].client_id;
		}
	}
}
